export type Theme = 'system' | 'light' | 'dark';

const KEY = 'taskpilot.theme';

export function readTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme | null) ?? 'system';
}

/**
 * Explicit choice wins over the OS setting; "system" removes both classes and
 * lets the media query decide again.
 */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.classList.remove('dark', 'light');
  if (theme !== 'system') root.classList.add(theme);
  localStorage.setItem(KEY, theme);
}
